import { FlexibleTableHeaderColumn } from "src/shared/components/data-display/FlexibleTable/flexible-table-items.interface"
import { EstadoPagoOrdenes } from "src/gql/schema"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import { HeaderProps } from "../../hooks/useHeaderProps"

const useEstatusPagoHeader = <T extends string>({
    headerValue,
    valueToDisplay,
}: HeaderProps<T>): FlexibleTableHeaderColumn => {
    const options = Object.values(EstadoPagoOrdenes).map((estado) => ({
        value: estado,
        valueToDisplay: formatTextWithCapitalize(estado),
    }))

    return {
        value: headerValue,
        valueToDisplay,
        filterMenu: options,
        isFilterUnique: false,
        filterSuggetions: false,
    }
}

export default useEstatusPagoHeader
